import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { translate } from '@jsverse/transloco';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-portal',
  templateUrl: './about-portal.component.html',
  styleUrls: ['./about-portal.component.scss'],
  standalone: false
})
export class AboutPortalComponent implements OnInit {
  portalVersion = environment.appVersion;
  buildNumber = environment.buildNumber;
  releaseDate = environment.releaseDate;
  tenant = 'https://dashboard.bankingcloud.temenos.com';

  buildRows: { icon: string; labelKey: string; value: string; color?: string }[] = [];

  resourceLinks: { icon: string; iconBg: string; labelKey: string; url: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<AboutPortalComponent>,
    private clipboard: Clipboard,
    private toastrService: CustomToastrService
  ) {}

  ngOnInit(): void {
    this.buildRows = [
      { icon: 'tag', labelKey: 'ABOUT.BUILD', value: this.buildNumber, color: 'var(--about-icon-build)' },
      { icon: 'schedule', labelKey: 'ABOUT.RELEASED_ON', value: this.releaseDate, color: 'var(--about-icon-released)' },
      { icon: 'layers_filled', labelKey: 'ABOUT.PORTAL_VERSION', value: this.portalVersion }
    ];

    this.resourceLinks = [
      {
        icon: 'menu_book',
        iconBg: 'rgba(41,50,118,0.09)',
        labelKey: 'ABOUT.USER_GUIDE',
        url: `${this.tenant}/userguide`
      },
      {
        icon: 'release_notes',
        iconBg: 'rgba(92,184,178,0.09)',
        labelKey: 'ABOUT.RELEASE_NOTES',
        url: `${this.tenant}/userguide/docs/category/release-notes-management-portal`
      }
    ];
  }

  close(): void {
    this.dialogRef.close();
  }

  copyToClipboard(value: string): void {
    if (!value || value === '-' || value.startsWith('__')) { return; }
    this.clipboard.copy(value);
    this.toastrService.successMessage(translate('ABOUT.COPIED'));
  }

  openLink(url: string): void {
    window.open(url, '_blank', 'noopener');
  }
}
